import io from 'socket.io-client';
import { showNotificationWS } from '../services/NotificationService';

export const startSocketIO = (jwt) => {
  const host = process.env.REACT_APP_WS_SERVER || 'http://localhost:3000';
  const socket = io.connect(host);
  socket.on('connect', function () {
      socket
          .emit('authenticate', {
              token: jwt
          }) //send the jwt
          .on('authenticated', function () {
              
          });
  });

  socket.on('unauthorized', function (msg) {
     
  });
  socket.on('error', (x) => console.log(x));

  socket.on('message', (msg) => {
    try{
      const decoded = JSON.parse(msg.message);
      showNotificationWS(decoded);
    } catch(error){
      console.log(error);
    }
  });

}



// WEBPACK FOOTER //
// ./src/services/SocketIOService.js